import React, { createContext, useContext, useState, useEffect } from 'react';

const DeviceContext = createContext();

export const useDevice = () => useContext(DeviceContext);

export const DeviceProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLaptop, setIsLaptop] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
  const handleResize = () => {
    const isMobileDevice = window.innerWidth <= 900; // Defina o limite de largura para dispositivos móveis
    const isLaptopDevice = window.innerWidth > 809 && window.innerWidth <= 1440; // Defina o limite de largura para laptops
    const isDesktopDevice = window.innerWidth > 1440;
    setIsMobile(isMobileDevice);
    setIsLaptop(isLaptopDevice);
    setIsDesktop(isDesktopDevice);
  };

  // Adicione um ouvinte de redimensionamento para atualizar o estado quando a janela for redimensionada
  window.addEventListener('resize', handleResize);

  // Execute a lógica de verificação de tamanho da janela quando o componente for montado
  handleResize();

  // Remova o ouvinte de redimensionamento quando o componente for desmontado para evitar vazamentos de memória
  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);


  return (
    <DeviceContext.Provider value={{ isMobile, isLaptop, isDesktop }}>
      {children}
    </DeviceContext.Provider>
  );
};
